import { request } from './client';
import type {
  AgentInfo,
  IssueLinkBody,
  IssueOptions,
  IssuedLink,
  Overview,
  TournamentPlayers,
  TournamentResults,
} from './types';

export const fetchAgent = (key: string, signal?: AbortSignal) => request<AgentInfo>('agent', { key, signal });

export const fetchOverview = (key: string, signal?: AbortSignal) => request<Overview>('overview', { key, signal });

export const fetchIssueOptions = (key: string, signal?: AbortSignal) =>
  request<IssueOptions>('issue/options', { key, signal });

export const issueLink = (key: string, body: IssueLinkBody) =>
  request<IssuedLink>('links', { key, method: 'POST', body });

export const fetchResults = (key: string, tournamentId: string, signal?: AbortSignal) =>
  request<TournamentResults>(`results/${encodeURIComponent(tournamentId)}`, { key, signal });

export const fetchPlayers = (key: string, tournamentId: string, signal?: AbortSignal) =>
  request<TournamentPlayers>(`results/${encodeURIComponent(tournamentId)}/players`, { key, signal });
